<template>
  <div>
    <BContainer>
      <div class="columns">
        <div class="column">
          <b-field grouped group-multiline>
            <a class="button is-primary" @click="openEditModal(null)">{{ $t('button.new') }}</a>
          </b-field>
        </div>
      </div>
      <b-table :data="data" ref="table" :striped="true" :mobile-cards="true" hoverable>
        <template slot-scope="props">
          <b-table-column field="code" :label="$t('validation.attributes.code')" sortable>{{
            props.row.code
          }}</b-table-column>
          <b-table-column field="code" :label="$t('validation.attributes.discount')" sortable
            >% {{ props.row.value }}</b-table-column
          >
          <b-table-column
            field="expireDate"
            :label="$t('validation.attributes.expireDate')"
            sortable
            >{{ props.row.expireDate | datetime }}</b-table-column
          >
          <b-table-column width="120" centered>
            <div class="buttons">
              <b-button icon-right="edit" @click="openEditModal(props.row.id)" />
              <b-button icon-right="trash-alt" @click="deleteItem(props.row.id)" />
            </div>
          </b-table-column>
        </template>
      </b-table>
    </BContainer>
  </div>
</template>

<script>
import ApiService from '../../../_api/api.service'
import DiscountEdit from './DiscountEdit.vue'

export default {
  data() {
    return {
      data: [],
      showDetailIcon: true
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      ApiService.get('/discount').then(data => {
        this.data = data
      })
    },
    openEditModal(id) {
      this.$buefy.modal.open({
        parent: this,
        props: { id },
        component: DiscountEdit,
        events: {
          saved: () => {
            this.getData()
          }
        }
      })
    },
    deleteItem(id) {
      this.$buefy.dialog.confirm({
        title: this.$t('title.deletingDiscount'),
        message: this.$t('description.deletingDiscountConfirmMessage'),
        confirmText: this.$t('button.deleteDiscount'),
        cancelText: this.$t('button.cancel'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          ApiService.delete('/discount', { data: { discountId: id } }).then(isDeleted => {
            if (isDeleted) {
              this.data = this.data.filter(p => p.id !== id)
            } else {
              this.deleteItem(id)
            }
          })
        }
      })
    }
  }
}
</script>
